import { render, staticRenderFns } from "./BaseYxPay.vue?vue&type=template&id=e1a99062&scoped=true"
import script from "./BaseYxPay.vue?vue&type=script&lang=js"
export * from "./BaseYxPay.vue?vue&type=script&lang=js"
import style0 from "./BaseYxPay.vue?vue&type=style&index=0&id=e1a99062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a99062",
  null
  
)

export default component.exports